import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import styles from '../profile-bar/ProfileBar.module.scss';
import hdrlogo from 'assets/images/hrd-logo.png';
import profileImg from 'assets/images/img-meher-razdan.png';
import pin from 'assets/images/profile-pin.svg';
import camera from 'assets/images/icn-instagram.svg';
import { commonActions } from '../../../stores/_actions';
import axios from 'axios';
import environment from 'environment';

function ProfileBar(props) {
  const dispatch = useDispatch();
  const customer = JSON.parse(localStorage.getItem('customer'));
  const profile = JSON.parse(localStorage.getItem('userProfile'));

  const [fimage, setFrontImage] = useState('');
  const [bimage, setBackImage] = useState('');
  const [filesize, setFileSize] = useState('');

  function imageValidation(file, face) {
    if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/svg+xml') {
      face == 'custimg' ? setFrontImage('') : setBackImage('');
    } else {
      //face == 'IDFront' ? customer.imgErr1 = 1 : customer.imgErr2 = 1

      const message = 'Invalid image format, Please upload only jpg, png, jpeg files';
      face == 'custimg' ? setFrontImage((fimage) => (fimage = message)) : setBackImage((bimage) => (bimage = message));
      // setFileSize((filesize)  => (filesize = 'invalid image format, Please upload only jpg, png, jpeg files'));
      return;
    }
  }

  function imageSizeValidation(file) {
    if (file.size > 2000000) {
      setFileSize((filesize) => (filesize = 'file size is greater then 2MB'));
      return;
    }
  }
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: null,
    IdType: null,
  };

  const cameraUpload = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    imageValidation(file, 'custimg');
    imageSizeValidation(file);
    formData(file, 'custimg');
    setTimeout(() => {
      // setCustomer((customer) => ({ ...customer, IdImageFront: file.name }));
      dispatch(commonActions.getCustDetailsByCode(payload));
      window.reload();
    }, 3000);
  };

  function formData(file, doctype) {
    const endpoint = environment.api.uploadMedia;
    const form_data = new FormData();
    form_data.append('Image', file, file.name);
    form_data.append('DocType', doctype);
    form_data.append('CustomerCode', profile?.CustomerCode);
    form_data.append('IDNO', customer?.IDNO);
    // let url = 'http://103.121.26.154:91/eastern/mobremitclient/api/admin/UploadMedia';
    axios
      .post(endpoint, form_data, {
        headers: {
          'content-type': 'multipart/form-data',
          'Content-Type': 'image/jpeg',
        },
      })
      .then((res) => {})
      .catch((err) => console.log(err));
  }

  return (
    <div className={styles.mainContainer__profileBar} style={{ margin: '23px 10px' }}>
      <img src={hdrlogo} alt="" />
      <div className={styles.profile}>
        <div className={styles.profile__profileImg}>
          <Link to="/myprofile" style={{ display: 'block', height: '100%' }}>
            <img src={props.profile?.ProfImage} alt="" />

            {/* {props.profile && props.profile.ProfileImage ? <img src={props.profile.ProfileImage} alt="" /> : <img src={profileImg} alt="" />} */}
          </Link>

          {/* {props.profile && props.profile.ProfileImage ? <img src={props.profile.ProfileImage} alt="" /> : <img src={profileImg} alt="" />} */}
        </div>
        <div className={styles.profile__profileName}>
          {props.profile && `${props.profile?.FirstName + ' ' + props.profile?.LastName}`}
          <span>
            <img src={pin} alt="" />
            {props.profile && props.profile?.Addr1}
          </span>
        </div>
        <br />
        <div className={styles.profile__iconButton}>
          <label className={styles.profile__iconButtonLabel} title="Upload Profile Image">
            +
            <input type="file" name="profImg" value="" className={styles.profile__iconButton} onChange={cameraUpload} />
          </label>
        </div>
      </div>
    </div>
  );
}

export { ProfileBar };
